import ApiService from "../api";

export default class FornecedorService extends ApiService {

    constructor() {
        super('/api/fornecedores')
    }

    listar() {
        return this.get("");
    }

    listaAutocomplete(search) {
        return this.get(`/autocomplete?search=${encodeURIComponent(search)}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}